import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import IconButton from 'material-ui/IconButton'
import Dialog from 'material-ui/Dialog'
import Clear from 'material-ui/svg-icons/content/clear'
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'
import PlanHeading from './PlanHeading'
import PlanFeatures from './PlanFeatures'
import { getToken, isAccountFree, isAccountPremium, checkJapanese } from '../../../lib'
import { ALertHeaderText } from '../../../components/Seminars/styles'
import config from '../../../config/config'
import Loader from 'react-loader'
import SubscriptionCheckoutForm from './SubscriptionCheckoutForm'
import SubscriptionUpdateForm from './SubscriptionUpdateForm'
import UpGradeDegradeComplete from './UpGradeDegradeComplete'
import { StripeProvider, Elements } from 'react-stripe-elements';

class Plans extends Component {
  state = {
    open: false,
    upgrade: false,
    error: false,
    plan: '',
    priceToPay: 0,
    loading: false,
    open_update: false
  }

  constructor(props) {
    super(props);
    if (props.campaign && props.stripeAccount != true) {
      this.state = {
        open: true,
        plan: 'premium'
      };
    }
  }

  subscriptionCreate = async (payload) => {
    const token = getToken()
    this.props.createPlan(token, payload)
  }

  async onToken(token) {
    this.setState({ loading: true })
    // 4242 4242 4242 4242
    // 5555 5555 5555 4444

    try {
      const payload = {
        stripeToken: token.id
      }
      let response = await fetch(`${config.URI}/api/v1/stripe_update_card`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authenticity-Token': getToken()
        },
        body: JSON.stringify(payload)
      })
      let res = await response.json()
      if (res.errors && Object.keys(res.errors).length >= 1) {
        this.setState({ loading: false })
        let error_message = res.errors.payment === "payment_failed" ? 'Please enter valid card information.' : res.errors.payment;
        if (checkJapanese()) {
          error_message = res.errors.payment === "payment_failed" ? '有効なカード情報を入力してください'  : '何かが間違っていました。もう一度やり直してください' ;
        }

        alert(error_message);
        return this.setState({ error: true, upgrade: false })
      }
      let warning = checkJapanese() ? 'カード情報の更新に成功しました。' : 'Card information was updated successfully.';
      alert(warning);
      window.location.search = "";

    } catch (error) {
      console.error(error)

    }

    this.setState({ loading: false })
  }

  handleOpen = (plan) => {
    this.setState({ open: true, plan })
  }

  handleUpdatePlan = (plan) => {
    this.setState({ open_update: true })
  }

  handleClose = () => {
    const token = getToken()
    if (!this.state.error) {
      this.props.returnUserIfUserExists(token)
      this.setState({ open: false, upgrade: false })
    } else {
      this.setState({ open: false, upgrade: false, error: false })
    }
  }

  closeModal = () => {
    window.location.href = "/admin/settings/manage-plans";
  }

  closeUpdateModal = () => {
    this.setState({ open_update: false })
  }

  handleUpgrade = plan => {
    const token = getToken()
    this.props.changePlan(token, plan)
    this.setState({ upgrade: true })
  }

  cancelPlan = () => {
    const token = getToken()
    this.props.cancelPlan(token)
    this.setState({ upgrade: true })
  }

  render() {
    let {
      userPlan,
      contract,
      location,
      campaign,
      stripeAccount,
      userId
    } = this.props

    let open = this.state.open;
    let plan = this.state.plan;
    if (campaign && stripeAccount != true) {
        open = true;
        plan = 'premium';
    }

    // Setup Stripe.js and the Elements provider
    const stripePromise = config.STRIPE_KEY;
    let max_rooms = 0;
    let max_accounts = 0;
    let created_users_count = 0;
    let created_rooms_count = 0;
    if (userPlan) {
      created_rooms_count = userPlan.data.created_rooms_count;
      created_users_count = userPlan.data.created_users_count;
      max_rooms = userPlan.data.max_room_num_per_user;
      max_accounts = userPlan.data.max_account_num;
      userPlan = userPlan.data.sessions_plan;
    }
    // userPlan = 'premium';
    console.log("userPlan", userPlan)
    return (
      <Paper className={this.props.view === 'desktop' ? "flex" : "flex plan-mobile"} style={{ width: '50vw', margin: '0px auto' }}>
        {this.state.loading && <Loader loaded={false} lines={13} length={20} width={10} radius={30}
          corners={1} rotate={0} direction={1} color="#000" speed={1}
          trail={60} shadow={false} hwaccel={false} className="spinner"
          zIndex={2e9} top="50%" left="50%" scale={1.00}
          loadedClassName="loadedContent" />}
        <div
          className={this.props.view === 'desktop' ? "h-100 w-50" : "h-100 w-100"}
          >
          <div style={{ height: '1vh', backgroundColor: '#4688F1' }} />
          <div
            style={{ height: '19vh' }}
            className="flex flex-column justify-between">
            <div>
              <PlanHeading contract={contract} plan={<FormattedMessage id='plan.trialPeriod' />} type="free" />
              <PlanFeatures
                location={location}
                plan="free"
                cancellationDate={this.props.cancellationDate}
                nextInvoiceDate={this.props.nextInvoiceDate}
                failedPaymentDate={this.props.failedPaymentDate}
                failedPaymentCount={this.props.failedPaymentCount}
                max_rooms={max_rooms}
                max_accounts={max_accounts}
              />
            </div>
            <div className="flex justify-center items-center mb3">
              {isAccountFree(userPlan) && <FlatButton
                disabled={isAccountFree(userPlan)}
                label={<FormattedMessage id="plan.currentPlan" />}
                hoverColor={'#c9c5c5'}
                backgroundColor={'#F6F6F6'}
                labelStyle={{
                  color: '#AFB8C4'
                }}
              />
              }
            </div>
          </div>
        </div>
        <div  className={this.props.view === 'desktop' ? "h-100 w-50" : "h-100 w-100"}
        style={{ borderLeft: '1px solid #d9d9d9' }}>
          <div style={{ height: '1vh', backgroundColor: '#C347E1' }} />
          <div
            className="flex flex-column justify-between" style={{textAlign: this.props.view !== 'desktop' ? 'center' : 'left'}}>
            <div>
              <PlanHeading
                contract={contract}
                plan={<FormattedMessage id='plan.premium' />}
                type="premium"
              />
              <PlanFeatures
                location={location}
                plan="premium"
                cancellationDate={this.props.cancellationDate}
                nextInvoiceDate={this.props.nextInvoiceDate}
                failedPaymentDate={this.props.failedPaymentDate}
                failedPaymentCount={this.props.failedPaymentCount}
                max_rooms={max_rooms}
                max_accounts={max_accounts}
              />
            </div>
            { this.props.stripeAccount ?
              <div className="flex justify-center items-center mb3 mt3">
                <FlatButton
                  onTouchTap={e => {
                    this.handleUpdatePlan()
                  }
                  }
                  label={<FormattedMessage id="plan.changePlan" />}
                  hoverColor={'#1d8e5d'}
                  backgroundColor={'#29B87A'}
                  labelStyle={{ color: '#FFFFFF' }}
                />
              </div>
            : <div className="flex justify-center items-center mb3 mt2">
              <FlatButton
                onTouchTap={e => {
                  if (isAccountPremium(userPlan)) {
                    return
                  }
                  this.handleOpen(
                    `premium`
                  )
                }
                }
                disabled={isAccountPremium(userPlan)}
                label={
                  isAccountPremium(userPlan)
                    ? <FormattedMessage id="plan.currentPlan" />
                    : <FormattedMessage id="plan.upgrade" />
                }
                hoverColor={isAccountPremium(userPlan) ? '#c9c5c5' : '#1d8e5d'}
                backgroundColor={
                  isAccountPremium(userPlan) ? '#F6F6F6' : '#29B87A'
                }
                labelStyle={{
                  color: isAccountPremium(userPlan) ? '#AFB8C4' : '#FFFFFF'
                }}
              />
            </div>}
            { isAccountPremium(userPlan) && <div className="flex justify-center items-center mb3">
              {this.props.cancellationDate == null && <FlatButton
                onTouchTap={e => {
                  this.handleOpen('free')
                }
                }
                label={
                  <FormattedMessage id="plan.backToFree" />
                }
                hoverColor={'#1d8e5d'}
                backgroundColor={
                  '#29B87A'
                }
                labelStyle={{
                  color: '#FFFFFF'
                }}
              />
              }
            </div> }
          </div>
        </div>
        <Dialog
          contentStyle={{ width: this.props.view === 'desktop' ? 'unset' : '95%' }}
          bodyStyle={{
            overflowY: 'auto',
            padding: this.props.view === 'mobile' || this.props.view === 'sm-mobile' ? '10px' : '20px'
          }}
          open={open}
          className="payment-dialog"

        >
          {this.state.error && <div>
            <div className="flex justify-between items-center mb3">
              <ALertHeaderText>
                <FormattedMessage id="plan.upgradeFailed" />
              </ALertHeaderText>
              <div>
                <IconButton
                  onTouchTap={this.closeModal}
                  iconStyle={{ fill: '#afb8c5' }}>
                  <Clear />
                </IconButton>
              </div>
            </div>
            <ALertHeaderText className="mb3">
              <FormattedMessage id="plan.paymentFailed" />
            </ALertHeaderText>
            <div className="flex justify-end">
              <FlatButton
                label={<FormattedMessage id="plan.close" />}
                labelStyle={{ color: '#AFB8C4' }}
                onTouchTap={this.handleClose}
              />
            </div>
          </div>
          }
          {this.props.isUpdatingPlan ?
            <div
              className="flex justify-center items-center"
              style={{ height: 300 }}>
                <FormattedMessage id="plan.updatingPlan" />
            </div>
            :
            <div>
              {this.state.upgrade && !this.props.planerror ?
                <UpGradeDegradeComplete handleClose={this.handleClose} />
                :
                <div>
                  <div className="flex justify-between items-center mb3">
                    <ALertHeaderText>
                      {plan === 'free' && <FormattedMessage id="plan.changePlan" />}
                    </ALertHeaderText>
                    <div>
                      <IconButton
                        onTouchTap={this.closeModal}
                        iconStyle={{ fill: '#afb8c5' }}>
                        <Clear />
                      </IconButton>
                    </div>
                  </div>
                  {plan === 'free'
                    ? <div
                      style={{ color: '#F01631', fontSize: 20 }}
                      className="mb3">
                      <FormattedMessage id="plan.noRefund" />
                    </div>
                    : ''}
                  {plan === 'premium' ?
                    <div>
                      <StripeProvider apiKey={stripePromise}>
                        <Elements>

                          <SubscriptionCheckoutForm userId={this.props.userId} paidUpgrade={this.props.paidUpgrade} subscriptionCreate={this.subscriptionCreate} closeModal={this.closeModal} handleClose={this.handleClose} />

                        </Elements>
                      </StripeProvider>
                    </div>
                    : ''
                  }
                  {plan === 'free'
                    ? <ALertHeaderText className="mb3">
                      <FormattedMessage id="plan.warning" />
                    </ALertHeaderText>
                    : ''}
                  <div className="flex justify-end">
                    {plan === 'free' && <div className="w4">
                      <FlatButton
                        label={
                          <FormattedMessage id="loggedInNavigation.cancel" />
                        }
                        fullWidth
                        labelStyle={{ color: '#AFB8C4' }}
                        onTouchTap={this.closeModal}
                      />
                    </div>
                    }
                    <div className="ml2 w6">
                      {plan === 'free' && <FlatButton
                        label={<FormattedMessage id="plan.backToFree" />}
                        hoverColor="#1e8257"
                        fullWidth
                        backgroundColor="#29B87A"
                        labelStyle={{ color: '#FFFFFF' }}
                        onTouchTap={e => this.cancelPlan()}
                      />
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </Dialog>

        <Dialog
          contentStyle={{ width: this.props.view === 'desktop' ? '47vw' : '95%' }}
          bodyStyle={{
            overflowY: 'auto',
            padding: this.props.view === 'mobile' || this.props.view === 'sm-mobile' ? '10px' : '20px'
          }}
          className="change-plan"
          open={this.state.open_update}
        >
          <div className="flex justify-between items-center mb3">
            <div>
              <IconButton
                onTouchTap={this.closeUpdateModal}
                iconStyle={{ fill: '#afb8c5' }}>
                <Clear />
              </IconButton>
            </div>
          </div>
          <div>
            <SubscriptionUpdateForm
              created_rooms_count={created_rooms_count}
              created_users_count={created_users_count}
              max_rooms={max_rooms}
              max_accounts={max_accounts}
              handleClose={this.closeUpdateModal}
            />
          </div>
        </Dialog>
      </Paper>
    )
  }
}

export default Plans



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/Plans.js